var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "900" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("edit-barcode-content")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-custom-lang-select", {
                    attrs: { value: _vm.lang },
                    on: {
                      input: function ($event) {
                        return _vm.selectLang($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("app-select-placement", {
                    attrs: { "full-control": "", layout: _vm.layout },
                    model: {
                      value: _vm.val.Placement,
                      callback: function ($$v) {
                        _vm.$set(_vm.val, "Placement", $$v)
                      },
                      expression: "val.Placement",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-select", {
                    attrs: { items: _vm.barcodeTypeItems },
                    model: {
                      value: _vm.val.BarcodeType,
                      callback: function ($$v) {
                        _vm.$set(_vm.val, "BarcodeType", $$v)
                      },
                      expression: "val.BarcodeType",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("text") },
                    model: {
                      value: _vm.val.Text.Translations[_vm.lang],
                      callback: function ($$v) {
                        _vm.$set(_vm.val.Text.Translations, _vm.lang, $$v)
                      },
                      expression: "val.Text.Translations[lang]",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("app-prop-select-autocomplete", {
                    attrs: {
                      label: _vm.$ct("prop"),
                      fancy: "",
                      items: _vm.props,
                      "allow-empty": "",
                    },
                    model: {
                      value: _vm.val.Prop,
                      callback: function ($$v) {
                        _vm.$set(_vm.val, "Prop", $$v)
                      },
                      expression: "val.Prop",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._l(_vm.val.Conditions, function (condition, i) {
            return _c(
              "w-transition-slide-height",
              { key: condition.key },
              [
                _vm.shouldShowKey(condition.key)
                  ? _c("app-field-condition-edit", {
                      attrs: {
                        value: condition,
                        "is-first": i == 0,
                        fields: _vm.conditionProps,
                      },
                      on: {
                        remove: function ($event) {
                          return _vm.removeCondition(i)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          }),
          _c(
            "w-row",
            [
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { flat: "", icon: "plus" },
                  on: {
                    click: function ($event) {
                      return _vm.addCondition()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("add-filter")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }